<template>
  <usertables
    v-bind:title="'Social Media'"
    v-bind:section="'socialmedia'"
  >
  </usertables>
</template>

<script>
  import usertables from './userTables'
  export default {
    name: 'socialMedia',
    components: {usertables}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user-class/socialMedia.vue